import { Tombstone } from './../models/Tombstone';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { Person } from 'app/models/Person';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  tombstones: any;
  constructor(private fireDatabase: AngularFireDatabase) {
    this.tombstones = this.fireDatabase.list('tombstone');
  }

  getTombstones() {
    return this.fireDatabase
      .list('tombstone', (ref) => ref.limitToFirst(10000))
      .valueChanges();
  }

  getCemeteries() {
    return this.fireDatabase.list('cemetery').valueChanges();
  }

  getPeople(name: string) {
    return this.fireDatabase
      .list('tombstone/' + name + '/person')
      .valueChanges();
  }

  getTombstone(name: string) {
    return this.fireDatabase.object('tombstone/' + name).valueChanges();
  }

  //serwisy poniżej do usunięcia, tylko do testów

  addTombstone(tombstone: Tombstone) {
    let listRef = this.fireDatabase.list('/tombstone');
    listRef.push(tombstone).catch((err) => console.log(err));
    // listRef.push({lat: tombstone.lat,lon: tombstone.lon, name: tombstone.name, person: tombstone.person})
  }

  getTombstonesList() {
    let list = this.fireDatabase.list('/tombstone');
    return list;
  }

  removeTombstone(key: string) {
    let listRef = this.fireDatabase.list('/tombstone');
    listRef.remove(key).catch((err) => console.log(err));
  }
}
